import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69eb38d863911b0014f0e4c5/wiretutor/src/components/ui/AppLogo.tsx");
